import ImageUtils from '../../utils/image-utils';
import AnalyticsHelper from '../../utils/analytics-helper';

export default class PreselectModal {
    constructor(parent) {
        this.parent = parent;
        this.data = parent.data;
        this.car = parent.car;
        this.pricing = parent.pricing;
        this.navigation = parent.navigation;
        this.el = parent.el.querySelector('.configurator--preselect-modal');
        this.content = this.el.querySelector('.modal-content');
        this.confirm = this.el.querySelector('.modal-confirm');
        this.closeModal = this.el.querySelector('.modal-close');
        this.template = _.template(parent.el.querySelector('#configurator--preselect-modal-template').innerHTML.replaceAll('\\', ''));
        this.utils = { rendition: ImageUtils.rendition };
        this.bind();
    }

    bind() {
        this.confirm.addEventListener('click', (e) => {
            e.preventDefault();
            this.hide();
            this.sendAnalytics('submit');
        });

        this.closeModal.addEventListener('click', (e) => {
            e.preventDefault();
            this.hide();
            this.sendAnalytics('cancel');
        });

        this.el.addEventListener('click', (e) => {
            if (!e.target.closest('.modal-container')) {
                this.hide();
            }
        });
    }

    async show(tempCar) {
        await this.pricing.waitForMTOPricing();
        const diff = {
            isDiffGrade: this.car.grade !== tempCar.grade,
            isDiffEngine: this.car.engine !== tempCar.engine,
            isDiffColour: this.car.colour !== tempCar.colour,
            isDiffTrim: this.car.trim !== tempCar.trim,
            isDiffWheel: this.car.wheel() !== tempCar.wheel(),
            isDiffAccessories: !_.isEqual(this.car.accessories.filter((a) => a !== this.car.wheel()), tempCar.accessories.filter((a) => a !== tempCar.wheel())),
            compareAccessories: tempCar.accessories.filter((a) => a !== tempCar.wheel() && !this.car.accessories.includes(a)).map((a) => this.data.accessories[a]),
        };

        this.modalData = {
            pricing: {
                format: (val) => this.pricing.format(val),
                gradePrices: this.pricing.getGradePrices(),
                colourPrices: this.pricing.getColourPrices(),
                trimPrices: this.pricing.getTrimPrices(),
                accessoryPrices: this.pricing.getAccessoryPrices(),
                wheelPrices: this.pricing.getWheelPrices(),
            },
            utils: this.utils,
            diff,
            compare: {
                car: this.car,
                data: this.car.data(),
                colourTrim: this.car.colourTrim(),
                grade: this.data.gradeMap[this.car.grade],
                accessories: diff.compareAccessories,
            },
        };

        this.content.innerHTML = this.template(this.modalData);
        this.el.showModal();
        this.el.querySelector('.modal-close').focus({ preventScroll: true });
        const selectedItem = document.querySelector('.selected-item');
        if (selectedItem) {
            selectedItem.scrollIntoView();
        }
        this.el.scrollTop = 0;
        this.sendAnalytics('open');
    }

    hide() {
        this.el.close();
    }

    sendAnalytics(action) {
        AnalyticsHelper.template(this.el, { data: this.modalData, action, sectionName: this.navigation.sectionName });
        AnalyticsHelper.push(this.el);
    }
}
